/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowTurnRightDown: {
  name: 'arrow-turn-right-down';
  data: string;
} = {
  name: 'arrow-turn-right-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 1A.5.5 0 0 1 3 .5h5A1.5 1.5 0 0 1 9.5 2v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L8.5 13.793V2a.5.5 0 0 0-.5-.5H3a.5.5 0 0 1-.5-.5Z" fill="currentColor"/></svg>`,
};
